import gql from 'graphql-tag';

import { artistSocialUrls } from 'app/shared/utils/socialLinks';

export const GET_ARTIST_PUBLIC_PROFILE = gql`
  query GetArtistPublicProfile($id: Int, $cachedSlug: String) {
    artist(id: $id, cachedSlug: $cachedSlug) {
      cachedSlug
      description
      id
      largeImageUrl
      bannerImageUrl
      priorCities {
        cachedSlug
        id
        title
      }
      socialUrls {
        ${artistSocialUrls.join(' ')}
      }
      title
      videos {
        artist {
          id
          cachedSlug
          title
        }
        cachedSlug
        city {
          id
          title
        }
        displayName
        id
        performedAt
        song {
          city {
            id
            title
          }
          id
          title
        }
        thumbnailImageUrl
      }
    }
  }
`;
